module.exports = __webpack_public_path__ + "img/added-service-unit-02.1a2b7756.png";